import React from 'react';
import Modal from '../Modal2';
import _ from 'lodash';
import AssetListCache from '../../queries/asset/AssetListCache';
import t from '../../i18n/I18n';
import { Checkbox } from '../../common/form';
import Dropdown from '../../common/Dropdown';
import { containsAnyFolder, filterAssets, isAnyNonProxyAsset, isAnyProxyAsset } from '../../util/SelectedItemUtil';
import { archiveResolutions, archiveStatusEnum, RESTORE_STATUS } from '../../util/Constants';
import { ArchiveQuery } from '../../queries/archive-restore/ArchiveQuery';
import './ArchiveModal.css';
import { RepoItem } from '../../autogenerated/ZoomBridge';

type Props = {
  assets: Array,
  onClose: Function,
  onRefreshPWD: Function
};
export default class ArchiveModal extends React.Component<Props> {
  _assetListCache: AssetListCache;
  resolution = [
    { label: archiveResolutions.HI_RES, isChecked: false, isVisible: false, isEnable: false },
    { label: archiveResolutions.MID_RES, isChecked: false, isVisible: false, isEnable: false },
    { label: archiveResolutions.LOW_RES, isChecked: false, isVisible: false, isEnable: false },
    { label: archiveResolutions.DIRECT, isChecked: false, isVisible: false, isEnable: false }
  ];
  storageTypes: Array<string> = window.gs.storageTypes ? window.gs.storageTypes.split(',') : ['S3'];
  
  storageOptions : Array<{key: string, value: string}> = this.storageTypes.length > 1 ? this.storageTypes.reduce((prevVal,currentVal,index,storageTypes) => {
    if(typeof(prevVal) === 'string'){
      let result = [{label: prevVal, value: prevVal}];
      result.push({label:storageTypes[index], value: storageTypes[index]});
       return result;
    } else {
        prevVal.push({label:storageTypes[index], value: storageTypes[index]});
        return prevVal;
    }
    }) : [{label: this.storageTypes[0], value: this.storageTypes[0]}]

  constructor(props) {
    super(props);
  }

  state = { isLoaded: false, storageValue: this.storageOptions[0].value, location: 'Global', keepSource: true };

  componentDidMount() {
    this.setOptions();
  }

  onToggle = (i) => {
    this.resolution[i].isChecked = !this.resolution[i].isChecked;
    this.forceUpdate();
  };

  onStorageChange = (value: string) => {
    this.setState({ storageValue: value });
  };

  getPresentTypes = (assets: Array<RepoItem>) => {
    const isType = {
      isProxy: false,
      isDirect: false
    };
    assets.forEach(asset => {
      if(asset.isProxy() && !isType.isProxy) {
        isType.isProxy = true;
      } 
      if(!asset.isProxy() && !isType.isDirect) {
        isType.isDirect = true;
      }
    });
    return isType;
  }

  getMultiAssetsLowResCheckbox = (assets: Array<RepoItem>) => {
    const checkbox = {enable: false, selected: false, visible: false};
    assets.forEach(asset => {
      if(asset.getLowResArchiveStatus() === archiveStatusEnum.VAB_NOT_ARCHIVED) {
        checkbox.enable = true;
        checkbox.visible = true;
      }
    });
    return checkbox;
  }

  returnCheckBoxStatusBasedOnArchiveStatus(status, isFolderCall, isDirectAsset) {
    if (isFolderCall || isDirectAsset) {
      return { enable: true, selected: false };
    }

    if (status == archiveStatusEnum.VAB_COPIED_TO_ARCHIVE) {
      return { enable: true, selected: true, visible: true };
    }

    if (status == archiveStatusEnum.VAB_ARCHIVED) {
      return { enable: true, selected: false, visible: true };
    }

    if (status == archiveStatusEnum.VAB_PENDING) {
      return { enable: false, selected: false, visible: true };
    }

    if (status == archiveStatusEnum.VAB_NOT_ARCHIVED) {
      return { enable: true, selected: false, visible: true };
    }

    return { enable: false, selected: false, visible: false };
  }

  isStatusNotAvailableOnAllAssets(items, status) {
    for (const item of items) {
      if (item[status] != archiveStatusEnum.VAB_NOT_APPLICABLE) return false;
    }
    return true;
  }

  getAvailableStatus(assets, status) {
    if (this.isStatusNotAvailableOnAllAssets(assets, status)) {
      return { enable: false, selected: false, visible: false };
    } else {
      //checkbox visible is true
      if (this.isAnyArchiveOrPending(assets, status)) {
        return { enable: true, selected: true, visible: true };
      } else {
        return { enable: false, selected: false, visible: true };
      }
    }
  }

  isAnyArchiveOrPending(items, status, isLowResOrDirect) {
    for (const item of items) {
      if (
        isLowResOrDirect ||
        item[status] == archiveStatusEnum.VAB_COPIED_TO_ARCHIVE ||
        item[status] == archiveStatusEnum.VAB_ARCHIVED ||
        item[status] == archiveStatusEnum.VAB_PENDING
      )
        return true;
    }
    return false;
  }
  setOptions() {
    const { assets } = this.props;
    let hiRes = {},
      midRes = {},
      lowRes = {},
      direct = {};
    const {isProxy, isDirect} = this.getPresentTypes(assets);
    let directExecuteQuery = false;
    const anyFolder = containsAnyFolder(assets);
    if (anyFolder) {
      hiRes = { enable: true, selected: true, visible: true };
      midRes = lowRes = direct = { enable: true, selected: false, visible: true };
    } else if (assets.length === 1) {
      const item = assets[0];
      if (item.isProxy()) {
        hiRes = this.returnCheckBoxStatusBasedOnArchiveStatus(item.getHiResArchiveStatus(), false, false);
        midRes = this.returnCheckBoxStatusBasedOnArchiveStatus(item.getMidResArchiveStatus(), false, false);
        lowRes = this.returnCheckBoxStatusBasedOnArchiveStatus(item.getLowResArchiveStatus(), false, false);
      } else {
        lowRes = this.returnCheckBoxStatusBasedOnArchiveStatus(item.getLowResArchiveStatus(), false, true);
        directExecuteQuery = true;
      }
    } else if(assets.length > 1) {
        if(isProxy) {
          hiRes = { enable: true, selected: true, visible: true };
        } else {
          directExecuteQuery = true;
        }
        if(isDirect) {
          direct = { enable: true, selected: false, visible: true };
        }
        lowRes = this.getMultiAssetsLowResCheckbox(assets);
    } 
    else {
      if (!isAnyProxyAsset(assets)) {
        directExecuteQuery = true;
        [hiRes, midRes, lowRes] = Array(3).fill({ enable: false, selected: false, visible: false });
      } else {
        hiRes = this.getAvailableStatus(assets, RESTORE_STATUS.HI_RES);
        midRes = this.getAvailableStatus(assets, RESTORE_STATUS.MID_RES);
        lowRes = this.getAvailableStatus(assets, RESTORE_STATUS.LOW_RES);

        if (isAnyNonProxyAsset(assets)) {
          direct = { enable: true, selected: false, visible: true };
        }
      }
    }

    if (directExecuteQuery) {
      direct = { enable: true, selected: true, visible: true };
      [hiRes, midRes, lowRes] = Array(3).fill({ enable: false, selected: false, visible: false });
      this.archive();
    } else {
      direct = { enable: false, selected: false, visible: false };
    }
    if (anyFolder || isDirect) {
      direct = { enable: true, selected: false, visible: true };
    }

    this.setResolutionOption(hiRes, midRes, lowRes, direct);
    this.setState({ isLoaded: true });
  }

  setResolutionOption(hiRes, midRes, lowRes, direct) {
    this.resolution[0].isChecked =
      hiRes.selected || (hiRes.enable && !midRes.enable && !lowRes.enable && !direct.enable);
    this.resolution[1].isChecked =
      midRes.selected || (midRes.enable && !hiRes.enable && !lowRes.enable && !direct.enable);
    this.resolution[2].isChecked =
      lowRes.selected || (lowRes.enable && !hiRes.enable && !midRes.enable && !direct.enable);
    this.resolution[3].isChecked =
      direct.selected || (direct.enable && !hiRes.enable && !midRes.enable && !lowRes.enable);

    this.resolution[0].isEnable = hiRes.enable;
    this.resolution[1].isEnable = midRes.enable;
    this.resolution[2].isEnable = lowRes.enable;
    this.resolution[3].isEnable = direct.enable;

    this.resolution[0].isVisible = hiRes.visible;
    this.resolution[1].isVisible = midRes.visible;
    this.resolution[2].isVisible = lowRes.visible;
    this.resolution[3].isVisible = direct.visible;
  }

  render() {
    const { onClose } = this.props;
    const { isLoaded } = this.state;
    const isSubmitEnable = this.resolution.some((e) => e.isChecked);
    const modalProps = {
      name: 'Archive Modal',
      title: t('ARCHIVE_TEXT'),
      onClose,
      buttons: [
        { label: t('CANCEL'), type: 'CANCEL', onClick: this.props.onClose },
        {
          label: t('ARCHIVE_TEXT'),
          type: 'PRIMARY',
          disabled: !isSubmitEnable,
          onClick: () => this.archive()
        }
      ]
    };
    return (
      <Modal {...modalProps} closeOnEsc closeOnOutsideClick>
        <div>
          <div className="content mb-2">
            {t('SELECT_RESOLUTION')}
          </div>
          {isLoaded ? (
            <>
              <div className="d-flex">
                {this.resolution.map((e, i) => {
                  return e.isVisible ? (
                    <div className="mr-4" key={`restore-item${i}`}>
                      <Checkbox
                        key={i}
                        label={e.label}
                        disabled={!e.isEnable}
                        checked={e.isChecked}
                        onChange={() => this.onToggle(i)}
                      />
                    </div>
                  ) : null;
                })}
              </div>
              <div className="container-mt">
                <div className="mt-3 mt-item-1">
                  <label className="content">{'Select Storage Type'}</label>
                  <div className="flex-row align-center search-wrapper" style={{ width: '200px' }}>
                    <Dropdown
                      theme="PLAIN"
                      size="SMALL"
                      anchor="RIGHT"
                      options={this.storageOptions}
                      value={this.state.storageValue}
                      onChange={this.onStorageChange}
                      tabIndexNotRequired={true}
                    />
                  </div>
                </div>
                <div className="flex-row align-center mt-3 mt-item-2">
                  <Checkbox
                    label={'Keep Source Copy'}
                    checked={this.state.keepSource}
                    onChange={() => {
                      this.setState({
                        keepSource: !this.state.keepSource
                      });
                    }}
                  />
                </div>
              </div>
            </>
          ) : null}
        </div>
      </Modal>
    );
  }

  archive() {
    const { assets } = this.props;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new ArchiveQuery(
      this.resolution[0].isChecked,
      this.resolution[1].isChecked,
      this.resolution[2].isChecked,
      this.resolution[3].isChecked,
      assetIds,
      this.state.storageValue,
      this.state.location,
      this.state.keepSource
    );
    query.run(this.props.onRefreshPWD);
    this.props.onClose(true);
  }
}
const styles = {
  asset: {
    width: '100%',
    background: 'var(--primary-header-bg)',
    color: 'var(--primary-font-color)',
    padding: '5px',
    display: 'flex',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    cursor: 'pointer',
    fontSize: '14px',
    marginBottom: '15px'
  }
};
